import { render, staticRenderFns } from "./LogDetail.vue?vue&type=template&id=46cdc81d&"
import script from "./LogDetail.vue?vue&type=script&lang=js&"
export * from "./LogDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports